module.exports = "<div class\"digitalPay\">\r\n    <wow-digital-pay-toggle-button\r\n        instrument-name=\"Account\"\r\n        icon=\"iconww-PayOnAccount\"\r\n        on-click=\"$ctrl.toggleSelected()\"\r\n        is-selected=\"$ctrl.isSelected()\"\r\n        amount=\"$ctrl.getPayingAmount()\"\r\n        should-show-paying-amount=\"$ctrl.shouldShowPayingAmount\">\r\n    </wow-digital-pay-toggle-button>\r\n</div>\r\n\r\n<div ng-if=\"$ctrl.hasListInstrumentsError\" class=\"digitalPayAccount\"></div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/digitalpay/account/digital-pay-account.component.html
// module id = 967
// module chunks = 1